import React from "react"
import { Outlet, useParams } from "react-router-dom"
import { Loader } from "src/components/global/Loader"
import { ModuleErrors } from "src/components/ui/ModuleErrors"
import { useActions, useAppState } from "src/state"

export function AgencyOperationsAdminThreadLayout() {

    const { threadId } = useParams()

    const { loading, currentItem, errors } = useAppState().threads
    const { subscribeToItem, unsubscribeFromItem } = useActions().threads

    React.useEffect(() => {
        subscribeToItem({ id: threadId });
        return () => {
            unsubscribeFromItem()
        }
    }, [threadId, subscribeToItem, unsubscribeFromItem])

    if (loading) return <Loader />
    if (!currentItem) return <Loader />

    return (
        <React.Fragment>
            <ModuleErrors errors={errors} />
            <Outlet/>
        </React.Fragment>
    )

}